
namespace Gamification.Gamification {

    export interface NodiPickerOptions {
        hideNodi?: number[];
    }

    @Serenity.Decorators.registerClass()
    export class NodiCheckGrid extends Serenity.EntityGrid<NodiRow, NodiPickerOptions> {
        protected getColumnsKey() { return NodiColumns.columnsKey; }
        protected getDialogType() { return NodiDialog; }
        protected getIdProperty() { return NodiRow.idProperty; }
        protected getLocalTextPrefix() { return NodiRow.localTextPrefix; }
        protected getService() { return NodiService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery, options: NodiPickerOptions) {
            super(container, options);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            this.openDialogsAsPanel = true;
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            return columns;
        }

        protected usePager() {
            return true;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);
            return buttons;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            //
            var request = this.view.params as Serenity.ListRequest;
            //
            if (this.options.hideNodi && this.options.hideNodi.length) {
                /* */
                request.Criteria = Serenity.Criteria.and([[Gamification.NodiRow.Fields.IdNodo], 'not in', [this.options.hideNodi]], request.Criteria);
            }

            return true;
        }
    }
}